// PrivateShowTicketNotice.js
import { connect } from 'react-redux';

import PrivateShowTicketNotice from '../component/PrivateShowTicketNotice.jsx';
import getUserData from '../selector/getUserData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import fetchUser from '../action/fetchUser.js';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';
import { FEATURE_DISPLAY_NAME } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.TICKET_NOTICE;
  const ticketNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const ticketNoticeId = ticketNoticeIds[0];
  const ticketNoticeSelectPath = [streamId, noticeType, ticketNoticeId];
  const noticeStatus = getLiveStreamData(
    state,
    ticketNoticeSelectPath,
    'status'
  );
  const userId = getLiveStreamData(state, ticketNoticeSelectPath, 'senderId');
  const username = getUserData(state, userId, 'username');
  const displayName = getUserData(state, userId, 'displayName');
  const isDisplayNameEnabled =
    getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1;
  const isUserFetching = userId
    ? getNetworkingData(state, ['user', userId], 'isFetching')
    : false;
  const isUserFetched = userId
    ? getNetworkingData(state, ['user', userId], 'isFetched')
    : false;
  const senderLevel = getLiveStreamData(
    state,
    ticketNoticeSelectPath,
    'senderLevel'
  );
  const senderBadges = getLiveStreamData(
    state,
    ticketNoticeSelectPath,
    'senderBadges'
  );
  const amount = getLiveStreamData(state, ticketNoticeSelectPath, 'amount');
  const type = getLiveStreamData(state, ticketNoticeSelectPath, 'type');
  return {
    userId,
    username,
    displayName,
    isDisplayNameEnabled,
    isUserFetching,
    isUserFetched,
    noticeStatus,
    senderLevel,
    senderBadges,
    amount,
    type,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateShowTicketNotice);
